import clsx from 'clsx';
import type { ComponentPropsWithoutRef } from 'react';

type Props = {
  title: string;
  isStart: boolean;
  isEnd: boolean;
  isRange: boolean;
} & ComponentPropsWithoutRef<'button'>;

export default function JobChangeStepRangeButton({
  title,
  isStart,
  isEnd,
  isRange,
  ...props
}: Props) {
  const isSelected = isStart || isEnd || isRange;

  return (
    <button
      {...props}
      type="button"
      className={clsx(
        'flex size-full items-center justify-center rounded-full text-sm hover:opacity-60',
        'border border-solid border-border bg-white text-main',
        isSelected && 'bg-primary! font-bold! text-white!'
      )}
    >
      {title}
    </button>
  );
}
